import { createFileRoute } from '@tanstack/react-router'

import KotaKabupatenPage from '@/components/pages/backoffice/_klb-penyuluh/_kotakab/containers/KotaKabupatenPage'

export const Route = createFileRoute('/_backoffice/klb-penyuluh/kotakab/')({
  component: KotaKabupatenPage
})
